import React from 'react'
import {camelCase} from '../../../../../utils';

const SweepParticipantAndAccount = ({item,pageJson,translations}) => {
  if(item !== undefined) {
    return (
      <div className="cc-detail-container gdocs-mleft-25">
        <div className="cc-detail-container__heading">{translations(pageJson.pageHeading)}</div>
        <div className="cc-detail-container__content">
          <dl className="cc-detail-container__horizontal-row">
            <dt>{translations(pageJson.textSweepType)}</dt>
            {
	            item.sweepType !== undefined
            	? <dd>{item.sweepType.name}</dd>
            	: <dd>&nbsp;</dd>
            }
            <dt>{translations(pageJson.textCrossBorder)}</dt>
            <dd>{camelCase(item.accountRegion)}</dd>
            <dt>{translations(pageJson.textCurrency)}</dt>
            {
	            item.currency !== undefined
            	? <dd>{item.currency.name}</dd>
            	: <dd>&nbsp;</dd>
            }
            <dt>{translations(pageJson.textMasterAccount)}</dt>
            <dd>
              {
                item.masterAccountData !== undefined
                ? <div style={{display: 'table-row'}}>
                     <span>{item.masterAccountData.accountType !== undefined ? item.masterAccountData.accountType.name + ',' : ''}</span>
                     <span>{item.masterAccountData.accountNumber !== undefined && item.masterAccountData.accountNumber !== '' ? item.masterAccountData.accountNumber + ',' : ''}</span>
                     <span>{item.masterAccountData.branchCode !== undefined ? item.masterAccountData.branchCode + ',' : ''}</span>
                     <span>{item.masterAccountData.country !== undefined ? item.masterAccountData.country.name + ',' : ''}</span>
                     <span>{item.masterAccountData.currency !== undefined ? item.masterAccountData.currency.name : ''}</span>
                     <br/>
                     <span>{item.masterAccountData.accountHolder !== undefined ? item.masterAccountData.accountHolder.name : ''}</span>
                     <br/>
                     <span>{item.masterAccountData.hsbcBankName !== undefined ? item.masterAccountData.hsbcBankName.name + ',' : ''}</span>
                     <span>{item.masterAccountData.bankName !== undefined && item.masterAccountData.bankName !== '' ? item.masterAccountData.bankName + ',': ''}</span>
                     <span>{item.masterAccountData.accountTitle !== undefined ? item.masterAccountData.accountTitle + ',' : ''}</span>
                     <span>{item.masterAccountData.tempRefrenceId !== undefined ? `(${item.masterAccountData.tempRefrenceId})` : ''}</span>
                    </div>
                  : ''
              }
            </dd>
            <dt>{translations(pageJson.textSubAccount)}</dt>
            <dd>
              {
                item.subAccountData !== undefined
                ? <div style={{display: 'table-row'}}>
                     <span>{item.subAccountData.accountType !== undefined ? item.subAccountData.accountType.name + ',' : ''}</span>
                     <span>{item.subAccountData.accountNumber !== undefined && item.subAccountData.accountNumber !== '' ? item.subAccountData.accountNumber + ',' : ''}</span>
                     <span>{item.subAccountData.branchCode !== undefined ? item.subAccountData.branchCode + ',' : ''}</span>
                     <span>{item.subAccountData.country !== undefined ? item.subAccountData.country.name + ',' : ''}</span>
                     <span>{item.subAccountData.currency !== undefined ? item.subAccountData.currency.name : ''}</span>
                     <br/>
                     <span>{item.subAccountData.accountHolder !== undefined ? item.subAccountData.accountHolder.name : ''}</span>
                     <br/>
                     <span>{item.subAccountData.hsbcBankName !== undefined ? item.subAccountData.hsbcBankName.name + ',' : ''}</span>
                     <span>{item.subAccountData.bankName !== undefined && item.subAccountData.bankName !== '' ? item.subAccountData.bankName + ',': ''}</span>
                     <span>{item.subAccountData.accountTitle !== undefined ? item.subAccountData.accountTitle + ',' : ''}</span>
                     <span>{item.subAccountData.tempRefrenceId !== undefined ? `(${item.subAccountData.tempRefrenceId})` : ''}</span>
                    </div>
                : ''
              }
            </dd>
            <dt>{translations(pageJson.textCashConReporting)}</dt>
            <dd>{item.cashConReporting === true ? 'Yes' : 'No'}</dd>
            {
              item.cashConReporting === true
              ? [
                  <dt>{translations(pageJson.bilateralLimits)}</dt>,
                  <dd>{item.bilateralLimits === true ? 'Yes' : 'No'}</dd>
                ]
              : ''
            }
            {
              item.cashConReporting === true
              ? [
                  <dt>{translations(pageJson.accountLimits)}</dt>,
                  <dd>{item.accountLimits === true ? 'Yes' : 'No'}</dd>
                ]
              : ''
            }
            {
              item.cashConReporting === true
              ? [
                <dt>{translations(pageJson.groupLimits)}</dt>,
                <dd>{item.groupLimits === true ? 'Yes' : 'No'}</dd>
                ]
              : ''
            }
          </dl>
        </div>
      </div>
    )
  }else {
    return null;
  }
}

export default SweepParticipantAndAccount;



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/CCPreview/SweepInstruction/SweepParticipantAndAccount.js